export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      sliderNumber: '',
      inputNumber: 0
    };
  },
  mounted() {
    this.sliderNumber = this.size;
    this.inputNumber = this.size;
  },
  methods: {
    sliderChange(val) {
      this.inputNumber = val;
    },
    inputChange(val) {
      console.log(val);
      console.log(typeof val);
      this.sliderNumber = val;
    }
  }
};